// test939
(939 && 0);
